import { useState, useCallback } from 'react';

export function useLoading(defaultValue: boolean = false) {
  const [loading, setLoading] = useState(defaultValue);
  const toggleLoading = useCallback(() => setLoading(l => !l), []);

  return {
    loading,
    toggleLoading,
  };
}
